import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
    extends: Line,
    mixins: [reactiveProp],
    chartData: {},
    props: ['options'],
    mounted () {
        // this.chartData is created in the mixin.
        // If you want to pass options please create a local options object
        this.chartData.datasets.forEach(elem => {
            elem.label = elem.label.split('-')[0]
          })
        this.renderChart(this.chartData, this.options)
    }
}